'use strict';

var taggedTemplateLiteral = require('./taggedTemplateLiteral-f923b98d.js');
var xstyledStyledComponents_es = require('./xstyled-styled-components.es-6e2bde7d.js');
var unsupportedIterableToArray = require('./unsupportedIterableToArray-f175acfa.js');
var utils_logger_logDeprecatedFeature_logDeprecatedFeature = require('./utils/logger/logDeprecatedFeature/logDeprecatedFeature.js');

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return unsupportedIterableToArray.arrayLikeToArray(arr);
}

var arrayWithoutHoles = _arrayWithoutHoles;

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

var iterableToArray = _iterableToArray;

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var nonIterableSpread = _nonIterableSpread;

function _toConsumableArray(arr) {
  return arrayWithoutHoles(arr) || iterableToArray(arr) || unsupportedIterableToArray.unsupportedIterableToArray(arr) || nonIterableSpread();
}

var toConsumableArray = _toConsumableArray;

function _templateObject() {
  var data = taggedTemplateLiteral.taggedTemplateLiteral(["\n  ", "\n  @media screen and (min-width: ", "px) {\n    ", ";\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var DEFAULT_BREAKPOINTS = {
  xs: 0,
  sm: 360,
  md: 768,
  lg: 1152,
  xl: 1366
}; // breakpoints is a utility to create mobile first responsive components

var breakpointsMedia = function breakpointsMedia() {
  return xstyledStyledComponents_es.breakpoints.apply(void 0, arguments);
};
var breakpointsMediaUp = function breakpointsMediaUp() {
  return xstyledStyledComponents_es.up.apply(void 0, arguments);
};
var breakpointsMediaDown = function breakpointsMediaDown() {
  return xstyledStyledComponents_es.down.apply(void 0, arguments);
};
var breakpointsMediaBetween = function breakpointsMediaBetween() {
  return xstyledStyledComponents_es.between.apply(void 0, arguments);
}; // Return the current breakpoint (based on viewport width)

var useBreakpointMedia = function useBreakpointMedia() {
  return xstyledStyledComponents_es.useBreakpoint();
}; // Return breakpoints defined in the theme (or the default breakpoints)

var useBreakpointsMedia = function useBreakpointsMedia() {
  return xstyledStyledComponents_es.useBreakpoints();
}; // Return true if the viewport width is greater than the specified breakpoint

var useBreakpointsMediaUp = function useBreakpointsMediaUp(breakpointName) {
  return xstyledStyledComponents_es.useUp(breakpointName);
}; // Return true if the viewport width is lower than the specified breakpoint

var useBreakpointsMediaDown = function useBreakpointsMediaDown(breakpointName) {
  return xstyledStyledComponents_es.useDown(breakpointName);
}; // Return the width of the viewport

var useViewportWidth = function useViewportWidth() {
  return xstyledStyledComponents_es.useViewportWidth();
}; // TODO: remove when replace breakpoints will be removed

var DEPRECATED_BREAKPOINTS = {
  mobile320: 320,
  mobile480: DEFAULT_BREAKPOINTS.sm,
  tablet768: DEFAULT_BREAKPOINTS.md,
  desktop1024: DEFAULT_BREAKPOINTS.lg,
  desktop1440: DEFAULT_BREAKPOINTS.xl
};

var media = function media(size, args) {
  return xstyledStyledComponents_es.css(_templateObject(), utils_logger_logDeprecatedFeature_logDeprecatedFeature.logDeprecatedFeature('You must to use the new version of breakpoints.'), size, xstyledStyledComponents_es.css.apply(void 0, toConsumableArray(args)));
};

var mobile320 = function mobile320() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return media(DEPRECATED_BREAKPOINTS.mobile320, args);
};
var mobile480 = function mobile480() {
  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }

  return media(DEPRECATED_BREAKPOINTS.mobile480, args);
};
var tablet768 = function tablet768() {
  for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    args[_key3] = arguments[_key3];
  }

  return media(DEPRECATED_BREAKPOINTS.tablet768, args);
};
var desktop1024 = function desktop1024() {
  for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
    args[_key4] = arguments[_key4];
  }

  return media(DEPRECATED_BREAKPOINTS.desktop1024, args);
};
var desktop1440 = function desktop1440() {
  for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
    args[_key5] = arguments[_key5];
  }

  return media(DEPRECATED_BREAKPOINTS.desktop1440, args);
};

exports.DEFAULT_BREAKPOINTS = DEFAULT_BREAKPOINTS;
exports.DEPRECATED_BREAKPOINTS = DEPRECATED_BREAKPOINTS;
exports.breakpointsMedia = breakpointsMedia;
exports.breakpointsMediaBetween = breakpointsMediaBetween;
exports.breakpointsMediaDown = breakpointsMediaDown;
exports.breakpointsMediaUp = breakpointsMediaUp;
exports.desktop1024 = desktop1024;
exports.desktop1440 = desktop1440;
exports.mobile320 = mobile320;
exports.mobile480 = mobile480;
exports.tablet768 = tablet768;
exports.toConsumableArray = toConsumableArray;
exports.useBreakpointMedia = useBreakpointMedia;
exports.useBreakpointsMedia = useBreakpointsMedia;
exports.useBreakpointsMediaDown = useBreakpointsMediaDown;
exports.useBreakpointsMediaUp = useBreakpointsMediaUp;
exports.useViewportWidth = useViewportWidth;
//# sourceMappingURL=breakpoints-ee0a4ae5.js.map
